import { z } from 'zod';
const EntryMenuSchema = z.lazy(() => z.object({
    id: z.string(),
    icon: z.string().optional(),
    count: z.number().or(z.string()).optional(),
    route: z.string().optional(),
    params: z.object({}).optional(),
    subMenu: z.array(EntryMenuSchema).optional(),
}));
//# sourceMappingURL=entry-menu.js.map